export default "__VITE_ASSET__322a3ccc__"